import { superCodeActions } from '../../services';

export const superCodeReducer = ( state = { items : [] }, action ) =>{
  switch(action.type){
    case superCodeActions.CREATED:
      return {...state, items:[...state.items.filter( code => code.superCode !== action.data.superCode ), ...action.data ] }
    case superCodeActions.IDENTIFIED:
      return {...state, items:[...state.items.filter( code => code.superCode !== action.data.superCode && code.additionalAccessoryAssignment?.length !== action.data.additionalAccessoryAssignment?.length), action.data] }
    default:
      return state;
  }
}